import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, MessageCircle, Users, BookOpen, Paperclip, CheckSquare, Settings, BarChart3, Plane } from 'lucide-react';
import { useIsMobile } from '../hooks/useIsMobile';
import { useAuth } from '../hooks/useAuth';
import { useTeamUnread } from '../hooks/useTeamUnread';
import BottomTabs from './BottomTabs';

const API_URL = process.env.REACT_APP_CRM_API_URL || 'http://localhost:5000/api/crm';

const Sidebar = ({ activePage = 'cotacoes' }) => {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [taskCounts, setTaskCounts] = useState({ active: 0, overdue: 0 });
  const { totalUnread: teamUnread } = useTeamUnread(profile?.id);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const resp = await fetch(`${API_URL}/tasks/counts?seller_id=default`);
        if (resp.ok) {
          const data = await resp.json();
          setTaskCounts(data);
        }
      } catch (e) {}
    };
    fetchCounts();
    const interval = setInterval(fetchCounts, 30000);
    return () => clearInterval(interval);
  }, []);

  if (isMobile) {
    return <BottomTabs />;
  }

  const badgeCount = taskCounts.active || 0;

  return (
    <div style={styles.sidebar} className="sidebar-desktop">
      <nav style={styles.nav}>
        <SidebarButton icon={<FileText size={20} />} label="Cotações" active={activePage === 'cotacoes'} onClick={() => navigate('/app/dashboard')} />
        <SidebarButton icon={<MessageCircle size={20} />} label="Conversas" active={activePage === 'conversas'} onClick={() => navigate('/app/conversas')} />
        <SidebarButton icon={<Users size={20} />} label="Equipe" active={activePage === 'equipe'} onClick={() => navigate('/app/equipe')} badge={teamUnread > 0 ? teamUnread : null} badgeColor="#25d366" />
        <SidebarButton icon={<BookOpen size={20} />} label="Base" active={activePage === 'base'} onClick={() => navigate('/app/base')} />
        <SidebarButton icon={<Paperclip size={20} />} label="Vouchers" active={activePage === 'vouchers'} onClick={() => navigate('/app/vouchers')} />
        <SidebarButton icon={<CheckSquare size={20} />} label="Tarefas" active={activePage === 'tarefas'} onClick={() => navigate('/app/tarefas')} badge={badgeCount > 0 ? badgeCount : null} badgeColor={taskCounts.overdue > 0 ? '#ef4444' : taskCounts.today > 0 ? '#f59e0b' : '#3b82f6'} />
        <SidebarButton icon={<BarChart3 size={20} />} label="Dashboard" active={activePage === 'dashboard'} onClick={() => navigate('/app/dashboard-pipeline')} />
        <SidebarButton icon={<Plane size={20} />} label="Aéreo" active={activePage === 'aereo'} onClick={() => navigate('/app/aereo')} />
      </nav>
      <div style={styles.navFooter}>
        <SidebarButton icon={<Settings size={20} />} label="Configurações" active={activePage === 'config'} onClick={() => navigate('/app/config')} />
      </div>
    </div>
  );
};

function SidebarButton({ icon, label, active, onClick, badge, badgeColor }) {
  const [hover, setHover] = useState(false);
  return (
    <button onClick={onClick} style={{ ...styles.navItem(active), backgroundColor: active ? '#10b981' : hover ? '#f3f4f6' : 'transparent' }} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {icon}
      <span style={styles.navLabel}>{label}</span>
      {badge && (<span style={{ ...styles.badge, backgroundColor: badgeColor || '#ef4444' }}>{badge > 99 ? '99+' : badge}</span>)}
    </button>
  );
}

const styles = {
  sidebar: { width: '280px', backgroundColor: 'white', borderRight: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '20px 0', height: '100%' },
  nav: { display: 'flex', flexDirection: 'column', gap: '8px', padding: '0 16px' },
  navFooter: { padding: '0 16px', borderTop: '1px solid #e5e7eb', paddingTop: '20px' },
  navItem: (active) => ({ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.2s', fontSize: '15px', fontWeight: '500', border: 'none', width: '100%', textAlign: 'left', color: active ? 'white' : '#6b7280', position: 'relative' }),
  navLabel: { fontSize: '15px' },
  badge: { marginLeft: 'auto', fontSize: '11px', fontWeight: '700', color: 'white', borderRadius: '10px', padding: '2px 7px', minWidth: '18px', textAlign: 'center', lineHeight: '14px' }
};

export default Sidebar;
